export default __webpack_public_path__ + "static/ms123-853ee34a1cbe4c2eac49a71b9615835f.png";